import flowRight from 'lodash/flowRight';

import { addOverlayControls } from '@eb/eds-structure';
import { addMainControls } from '@eb/eds-structure';
import { addFocusDrawerControls } from '@eb/eds-structure';

import { trackBranchIOEvent } from './gaTracking';
/**
 * Enhances a component (typically `SiteStructure`) with useful HOC controls.
 * Also useful for enhancing mock components in unit tests.
 * @param {import('react').Component} component The component to enhance
 * @returns {import('react').Component} Enhanced component
 */
export const enhance = flowRight(
    addOverlayControls,
    addMainControls,
    addFocusDrawerControls,
);

export const branchEvents = () => {
    const eventsToTrack = [
        'didShowJourney',
        'didClickJourneyCTA',
        'didClickJourneyClose',
    ]; // List of events to track

    const listener = function (eventName, data) {
        const journeyName =
            data?.journey_link_data?.journey_name +
            ' - ' +
            data?.journey_link_data?.journey_id;
        if (eventsToTrack.includes(eventName)) {
            // If is an event to track and cookies banner is not displayed, track it.
            trackBranchIOEvent({ eventName, journeyName });
            if (
                eventName === 'didShowJourney' &&
                window?.evidon?.banner?.isVisible()
            ) {
                // If cookies banner is displayed and also the journey, track it.
                trackBranchIOEvent({
                    eventName: 'cookiesBannerDisplayed',
                    journeyName,
                });
            }
        }
    };

    window?.branch?.removeListener(listener); // first remove it to be sure to don't duplicate the listener
    window?.branch?.addListener(listener);
};
